export type SNACKBAR_TYPES = 'INFO' | 'ERROR';

export class SnackbarConfig {
  public duration;

  constructor(public message: string, public type: SNACKBAR_TYPES = 'INFO', _duration?: number) {
    this.duration = _duration || (this.type === 'INFO' ? 2000 : 6000);
  }
}
